app.views.transactionHistory = app.views.base.extend({
  childEvents: {
    'change [data-trasaction-fromDate]': 'onChangeTransactionFromDate',
    'change [data-trasaction-toDate]': 'onChangeTransactionToDate',
    'click [data-filter-accounts]': 'toggleAccountFilter',
    'click [data-filter-account-option]': 'onCheckAccountFilter',
    'click [data-print-tran-history]': 'onPrintTransactionHistory',
    'click [data-submit]': 'showSpinner',
    'click [data-toggle-details]': 'onToggleDetails'
  },
  attr: {
    transactionFrom: 'data-trasaction-fromDate',
    transactionTo: 'data-trasaction-toDate',
    accountFilter: 'data-account-filter',
    filterAccountsButton: 'data-filter-accounts',
    spinner: 'data-form-spinner'
  },
  classes: {
    picker: 'picker',
    selectContainerOpen: 'select2-container--open',
    transactionHistoryTablePlus: 'transaction-history-table-plus',
    transactionHistoryTableMinus: 'transaction-history-table-minus'
  },
  settings: {
    displayDateFormat: 'DD/MM/YYYY',
    daysTransactionLimit: 90
  },
  /**
  * Initialise Transaction History Listener
  * @public
  * @constructor
  */
  init: function init() {
    this.initTransactionsFromDatePicker();
    this.initTransactionsToDatePicker();
  },
  /**
  * Initialise TransactionsFromDatePicker
  * @private
  */
  initTransactionsFromDatePicker: function initTransactionsFromDatePicker() {
    var _this = this;
    var datepicker = $('body').find('[' + this.attr.transactionFrom + ']');
    var maxDate = new Date();
    maxDate.setDate(maxDate.getDate() - 1);
    if (datepicker.length > 0) {
      var startDate = datepicker.val();
      var options = $.extend(app.options.datepicker(), {
        max: maxDate,
        onOpen: function onOpen() {
          setTimeout(function () {
            datepicker.pickadate('set').set('select', datepicker.val(), {
              format: 'dd-mm-yyyy'
            });
          }, 1);
        },
        onClose: function onClose() {
          $('.' + _this.classes.picker).find('.' + _this.classes.selectContainerOpen).remove();
        }
      });
      datepicker.pickadate(options);
      datepicker.val(startDate);
    }
  },
  /**
  * Initialise TransactionsToDatePicker
  * @private
  */
  initTransactionsToDatePicker: function initTransactionsToDatePicker() {
    var _this = this;
    var datepicker = $('body').find('[' + this.attr.transactionTo + ']');
    if (datepicker.length > 0) {
      var startDate = datepicker.val();
      var options = $.extend(app.options.datepicker(), {
        max: new Date(),
        onOpen: function onOpen() {
          setTimeout(function () {
            datepicker.pickadate('set').set('select', datepicker.val(), {
              format: 'dd-mm-yyyy'
            });
          }, 1);
        },
        onClose: function onClose() {
          $('.' + _this.classes.picker).find('.' + _this.classes.selectContainerOpen).remove();
        }
      });
      datepicker.pickadate(options);
      datepicker.val(startDate);
    }
  },
  /**
  * On change of TransactionFrom date, update TransationTo date if required
  * @public
  */
  onChangeTransactionFromDate: function onChangeTransactionFromDate() {
    var from = $('[' + this.attr.transactionFrom + ']');
    var to = $('[' + this.attr.transactionTo + ']');
    var fromDate = moment(from.val(), this.settings.displayDateFormat);
    var toDate = moment(to.val(), this.settings.displayDateFormat);
    var diff = Math.abs(toDate - fromDate);
    var days = Math.abs(Math.ceil(diff / (1000 * 3600 * 24)));
    if (moment(from.val(), this.settings.displayDateFormat) > new Date()) {
      var currentDate = moment().subtract('months', 1).format(this.settings.displayDateFormat);
      from.val(currentDate);
    }
    if (days > this.settings.daysTransactionLimit || fromDate > toDate) {
      var newDate = moment(from.val(), this.settings.displayDateFormat).add('days', this.settings.daysTransactionLimit).format(this.settings.displayDateFormat);
      if (moment(newDate, this.settings.displayDateFormat) > new Date()) {
        newDate = moment().format(this.settings.displayDateFormat);
      }
      to.val(newDate);
    }
  },
  /**
  * On change of TransationTo date, update TransactionFrom date if required
  * @public
  */
  onChangeTransactionToDate: function onChangeTransactionToDate() {
    var from = $('[' + this.attr.transactionFrom + ']');
    var to = $('[' + this.attr.transactionTo + ']');
    var fromDate = moment(from.val(), this.settings.displayDateFormat);
    var toDate = moment(to.val(), this.settings.displayDateFormat);
    var diff = toDate - fromDate;
    var days = Math.abs(Math.ceil(diff / (1000 * 3600 * 24)));
    if (moment(to.val(), this.settings.displayDateFormat) > new Date()) {
      var currentDate = moment().format(this.settings.displayDateFormat);
      to.val(currentDate);
    }
    if (days > this.settings.daysTransactionLimit || fromDate > toDate) {
      var newDate = moment(to.val(), this.settings.displayDateFormat).subtract('days', this.settings.daysTransactionLimit).format(this.settings.displayDateFormat);
      from.val(newDate);
    }
  },
  /**
   * On action print transaction history
   * @public
   */
  onPrintTransactionHistory: function onPrintTransactionHistory(e) {
    e.preventDefault();
    window.print();
  },
  showSpinner: function showSpinner() {
    $('[' + this.attr.spinner + ']').show();
  },
  /**
  * Button functionality for transaction history
  * @public
  */
  onToggleDetails: function onToggleDetails(e) {
    var _this = this;
    var currentElement = $(e.currentTarget);
    var detailsRow = $(e.currentTarget).closest('tr').next('tr');
    if ($(detailsRow).is(':visible')) {
      $(detailsRow).hide();
      $(currentElement).hide();
      $(currentElement).closest('tr').find('.' + _this.classes.transactionHistoryTablePlus).show();
    } else {
      $(detailsRow).show();
      $(currentElement).hide();
      $(currentElement).closest('tr').find('.' + _this.classes.transactionHistoryTableMinus).show();
    }
    return false;
  }
});